import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { MdEdit, MdOutlineChevronRight } from "react-icons/md";
import Model from "../Model";
import { SubmitBtn } from "../Styles/InputStyles";
import { useNavigate } from "react-router-dom";
import { FaCouch, FaPlug, FaToilet, FaLock, FaFan, FaTree, FaLaptop, FaUtensils, FaBoxOpen } from "react-icons/fa"
import Tooltip from "../Tooltip";
const PropertyModal = ({
    isOpen,
    propertyAssets,
    setIsModalOpen,
    setIsAssignmentDetails,
    selectedData,
    setIsEditAssignmentDetails,
    setSelectedProperty,
    setIsMaintenanceDetails,
    navigate,
}) => {
    if (!isOpen) return null;

    const statusStyles = {
        1: "bg-green-100 text-green-700 text-xs border-green-300 border w-18 h-7 flex items-center justify-center rounded-full",
        2: "bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-18 h-7 flex items-center justify-center rounded-full",
        3: "bg-rose-100 text-rose-700 text-xs border-rose-300 border w-18 h-7 flex items-center justify-center rounded-full",
        4: "bg-gray-100 text-gray-800 text-xs border-gray-300 border w-18 h-7 flex items-center justify-center rounded-full",
    };

    const statusText = {
        1: "Active",
        2: "In Maintenance",
        3: "Disposed",
        4: "In Use",
    };

    const handleEditOpen = (asset) => {
        setIsModalOpen(false);
        setIsEditAssignmentDetails(true);
        setSelectedProperty(asset);
    };
    const handleMaintenanceOpen = (asset) => {
        setIsModalOpen(false);
        setIsMaintenanceDetails(true);
        setSelectedProperty(asset);
    };
    const goToDMaintenanceDetail = (asset) => {
        navigate(`/asset/list/maintenance/${asset.assetId}/${asset.propId}`, { state: { asset: asset } });
    };
    return (
        <Model
            width={`w-11/12 max-w-md`}
            setOpenModel={setIsModalOpen}
            title="Asset Assigned Properties"
        >
            {propertyAssets?.length > 0 ? (
                <div>
                    {propertyAssets.map((asset, index) => (
                        <div key={index} className="p-2 bg-gray-100 rounded-lg mb-4">
                            <div className="p-4 bg-white rounded-xl border border-gray-200 shadow-sm mb-3">
                                <div className="flex justify-between items-start">
                                    <div>
                                        <h3 className="font-medium text-gray-800">{asset.name}</h3>
                                        <p className="text-xs text-gray-400">
                                            {asset.unitCount} unit(s) assigned
                                        </p>
                                    </div>


                                </div>
                                <div className="flex space-x-2">
                                    <div
                                        className={`px-4 py-2 rounded-full text-xs font-semibold ${statusStyles[asset.status] || "bg-gray-100 text-gray-600"
                                            }`}
                                    >
                                        {statusText[asset.status] || "Not Assigned"}
                                    </div>
                                    <button
                                        className="text-primary-color"
                                        title="Edit Assign Asset"
                                        onClick={() => handleEditOpen(asset)}
                                    >
                                        <MdEdit />
                                    </button>
                                </div>
                            </div>
                            {/* <div className="flex justify-between items-center mt-2">
                                <button
                                    className="flex items-center border px-3 py-1 justify-center rounded-lg border-gray-200 mt-2 bg-white text-gray-600"
                                    title="Add Maintenance Detail"
                                    onClick={() => handleMaintenanceOpen(asset)}
                                >
                                    <GoPlusCircle className="mr-1 -mt-0.5" />
                                    Maintenance Detail
                                </button>
                                <div className="cursor-pointer" onClick={() => goToDMaintenanceDetail(asset)}><MdOutlineChevronRight className="text-gray-600" size={24} /></div>
                            </div> */}
                            <div className="flex justify-between items-center mt-3">
                                <button
                                    onClick={() => handleMaintenanceOpen(asset)}
                                    className="text-sm text-blue-600 hover:underline"
                                >
                                    + Add Maintenance
                                </button>

                                <button
                                    onClick={() => goToDMaintenanceDetail(asset)}
                                    className="text-gray-400 hover:text-gray-700"
                                >
                                    <MdOutlineChevronRight size={22} />
                                </button>
                            </div>

                        </div>
                    ))}
                </div>
            ) : (
                <div className="items-center flex flex-col justify-center">
                    <img
                        src={Images.NoFound}
                        alt="Property not assigned"
                        className="object-cover h-52"
                    />
                    <p className="text-gray-600 text-sm text-center mb-4">
                        No properties have been assigned to that asset yet.{" "}
                    </p>
                    <SubmitBtn
                        onClick={() => {
                            setIsAssignmentDetails({ isAssignment: true, selectedData });
                            setIsModalOpen(false);
                        }}
                    >
                        Assign Property
                    </SubmitBtn>
                </div>
            )}
        </Model>
    );
};

const Table = ({
    apiData,
    setSelectedData,
    setViewDetail,
    setIsAssignmentDetails,
    selectedData,
    setIsEditAssignmentDetails,
    setSelectedPropertyAssets,
    selectedPropertyAssets,
    setSelectedProperty,
    setIsMaintenanceDetails,
}) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handlePropertyClick = (item) => {
        setSelectedPropertyAssets(item.propertyAssets);
        setIsModalOpen(true);
        setSelectedData(item);
    };

    const viewDetail = (item) => {
        setViewDetail(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const assignData = (item) => {
        setIsAssignmentDetails(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    }

    const ActionBtns = (item) => {
        return (
            <Tooltip label="View details">
                <button
                    onClick={() => viewDetail(item)}
                    className="ml-auto text-gray-400 hover:text-gray-700 transition"
                >
                    <MdOutlineChevronRight size={22} />
                </button>
            </Tooltip>
        );
    };
    useEffect(() => {
        if (apiData) {

            const tempData = apiData.map((item) => ({
                assetName: showAssetName(item),
                category: getCategory(item.type),
                vendor: item.vendorName || "-",
                // property: (
                //     item.propertyAssets.length > 0 ?
                //         <button
                //             onClick={() => handlePropertyClick(item)}
                //             className="text-blue-500"
                //         >
                //             View
                //         </button>
                //         :
                //         <button
                //             onClick={() => assignData(item)}
                //             className="text-blue-500"
                //         >
                //             + Assign
                //         </button>

                // ),
                assignedTo: getAssignedTo(item),
                assetId: '#' + item.id,
                status: getStatus(item.status),
                action: ActionBtns(item),
                count: item.total,
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getAssignedTo = (item) => {
        return ((
            item.propertyAssets.length > 0 ? (
                <button
                    onClick={() => handlePropertyClick(item)}
                    className="text-blue-600 text-sm font-medium hover:underline"
                >
                    View ({item.propertyAssets.length})
                </button>
            ) : (
                <button
                    onClick={() => assignData(item)}
                    className="text-green-600 text-sm font-medium hover:underline"
                >
                    + Assign
                </button>
            )
        )
        );
    }

    const showAssetName = (item) => {
        const assetTypeMapping = {
            1: { name: "Furniture & Fixtures", icon: <FaCouch /> },
            2: { name: "Electrical & Appliances", icon: <FaPlug /> },
            3: { name: "Plumbing & Sanitary", icon: <FaToilet /> },
            4: { name: "Security & Access", icon: <FaLock /> },
            5: { name: "HVAC", icon: <FaFan /> },
            6: { name: "Outdoor Assets", icon: <FaTree /> },
            7: { name: "IT & Networking", icon: <FaLaptop /> },
            8: { name: "Kitchen Equipment", icon: <FaUtensils /> },
            9: { name: "Miscellaneous", icon: <FaBoxOpen /> },
        };

        const category = assetTypeMapping[item.type];

        return (
            <div className="flex items-start gap-3">
                <div className="mt-1 text-gray-500">{category?.icon}</div>

                <div className="flex flex-col min-w-0">
                    <span className="font-medium text-gray-800 truncate">
                        {item.name}
                    </span>
                    <span className="text-xs text-gray-400">
                        {category?.name}
                    </span>
                </div>
            </div>
        );
    };


    const showAssetNameOld = (item) => {
        const assetTypeMapping = {
            1: { name: "Furniture & Fixtures", icon: <FaCouch className="mr-2 text-gray-600" /> },
            2: { name: "Electrical & Appliances", icon: <FaPlug className="mr-2 text-gray-600" /> },
            3: { name: "Plumbing & Sanitary", icon: <FaToilet className="mr-2 text-gray-600" /> },
            4: { name: "Security & Access Control", icon: <FaLock className="mr-2 text-gray-600" /> },
            5: { name: "HVAC (Heating, Ventilation & Air Conditioning)", icon: <FaFan className="mr-2 text-gray-600" /> },
            6: { name: "Outdoor & Common Area Assets", icon: <FaTree className="mr-2 text-gray-600" /> },
            7: { name: "IT & Networking Equipment", icon: <FaLaptop className="mr-2 text-gray-600" /> },
            8: { name: "Kitchen Equipment & Accessories", icon: <FaUtensils className="mr-2 text-gray-600" /> },
            9: { name: "Miscellaneous Assets", icon: <FaBoxOpen className="mr-2 text-gray-600" /> },
        }

        const categoryInfo = assetTypeMapping[item.type] || { name: "-", icon: null }
        return (
            <div className="flex flex-col gap-1">
                <span className="text-gray-600 text-sm font-medium">{item?.name}</span>
                <span className="text-gray-400 text-sm">{categoryInfo.name}</span>
            </div>
        );
    };

    const getCategory = (type) => {
        const assetTypeMapping = {
            1: { name: "Furniture & Fixtures", icon: <FaCouch className="mr-2 text-gray-600" /> },
            2: { name: "Electrical & Appliances", icon: <FaPlug className="mr-2 text-gray-600" /> },
            3: { name: "Plumbing & Sanitary", icon: <FaToilet className="mr-2 text-gray-600" /> },
            4: { name: "Security & Access Control", icon: <FaLock className="mr-2 text-gray-600" /> },
            5: { name: "HVAC (Heating, Ventilation & Air Conditioning)", icon: <FaFan className="mr-2 text-gray-600" /> },
            6: { name: "Outdoor & Common Area Assets", icon: <FaTree className="mr-2 text-gray-600" /> },
            7: { name: "IT & Networking Equipment", icon: <FaLaptop className="mr-2 text-gray-600" /> },
            8: { name: "Kitchen Equipment & Accessories", icon: <FaUtensils className="mr-2 text-gray-600" /> },
            9: { name: "Miscellaneous Assets", icon: <FaBoxOpen className="mr-2 text-gray-600" /> },
        }

        const categoryInfo = assetTypeMapping[type] || { name: "-", icon: null }
        return (
            <div className="flex items-center">
                {categoryInfo.icon}
                <span>{categoryInfo.name}</span>
            </div>
        )
    }

    const getStatus = (status) => {
        if (status == 1) {
            return <Resolved>Active</Resolved>;
        } else if (status == 2) {
            return <Pending>In Maintanance</Pending>;
        } else if (status == 3) {
            return <Disposed>Disposed</Disposed>;
        } else {
            return <Assigned>In Use</Assigned>;
        }
    };


    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Asset Name",
                    accessor: "assetName",
                },
                {
                    Header: "Category",
                    accessor: "category",
                },
            ];
        }

        return [
            // {
            //     Header: "Asset Id",
            //     accessor: "assetId",
            //     width: '15%'
            // },

            {
                Header: "Asset Name",
                accessor: "assetName",
                width: '30%'
            },
            {
                Header: "Assigned To",
                accessor: "assignedTo",
                width: '15%'
            },
            {
                Header: "Quantity",
                accessor: "count",
                width: '10%'
            },
            {
                Header: "Vendor",
                accessor: "vendor",
                width: '15%'
            },
            {
                Header: "",
                accessor: "action",
                width: '10%'
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        setCurrentPage(pageIndex);
    }, [pageIndex]);
    return (
        <>
            <CustomTable {...getTableProps()} style={{ width: '100%' }}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}

                                    style={{ width: column.width }}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>

                <Tbody
                    {...getTableBodyProps()}
                    className={apiData?.length > 0 ? "border-b" : ""}
                >
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Assigned To:</strong>{" "}
                                                    {data[rowIndex].property}
                                                </li>

                                                <li className="flex gap-2">
                                                    <strong>Quantity:</strong> {data[rowIndex].count}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Vendor:</strong>{" "}
                                                    {data[rowIndex].vendor}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>
                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75 "
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
            <PropertyModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                propertyAssets={selectedPropertyAssets}
                setIsModalOpen={setIsModalOpen}
                setIsAssignmentDetails={setIsAssignmentDetails}
                selectedData={selectedData}
                setIsEditAssignmentDetails={setIsEditAssignmentDetails}
                setSelectedProperty={setSelectedProperty}
                setIsMaintenanceDetails={setIsMaintenanceDetails}
                navigate={navigate}
            />
        </>
    );
};

const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${({ hasdata }) =>
    hasdata === "true" ? "border-b" : ""}`;
const Tr = tw.tr`${({ hasdata }) =>
    hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Pending = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-28 h-7 flex items-center justify-center rounded-full`;
const Disposed = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-28 h-7 flex items-center justify-center rounded-full`;
const Resolved = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-28 h-7 flex items-center justify-center rounded-full`;
const Assigned = tw.div`bg-blue-50 text-blue-700 text-xs border-blue-100 border w-28 h-7 flex items-center justify-center rounded-full`;

export default Table;
